/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
        function stateConfig($stateProvider) {
            $stateProvider.state('estadisticas', {
                parent: 'admin',
                url: '/admin/estadisticas',
                data: {
                    pageTitle: 'admin.estadisticas.title'
                },
                ncyBreadcrumb: {
                    label: "admin.estadisticas.title",
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/estadisticas/estadisticas.html',
                        controller: 'EstadisticasController',
                        controllerAs: 'ctrl'
                    }
                }
            })
            ;
        }
})();
